<template>
  <section class="co-bg-striped">
    <div class="co-container-sm px-5 py-10">
      <!-- はじ副業コースのみ、申し込みフォームへのボタン -->
      <div
        v-if="sidejob"
        class="co-display-13 text-center"
      >
        <div class="te-banner-limited-border relative mb-2 inline-block border-b border-b-co-gray-700">
          <span class="font-bold">今すぐ申し込んで受講開始すると</span>
        </div>
        <div class="text-center">
          <div class="co-display-10 mb-3 font-bold">
            平均約2ヶ月後に副業が始められる！
          </div>
          <a
            href="#apply"
            target="_blank"
            style="width: 15.25rem"
            class="co-btn-primary mb-6 inline-flex items-center justify-center"
            @click.prevent="scrollTo('apply')"
          >
            今すぐ申し込む
            <FontAwesomeIcon
              :icon="faAngleRight"
              class="fa-fw inline h-4"
            />
          </a>
        </div>
      </div>

      <!-- 無料相談botchanへのリンクボタン -->
      <div class="co-display-12 mb-3 text-center">
        <span class="font-bold">
          <slot name="counselingLead">
            迷っている方は気軽に相談
          </slot>
        </span>
        <div class="text-center">
          <a
            href="/counseling/htmlcss-schedule"
            style="width: 15.25rem"
            class="bot_open co-btn-counseling mt-3"
          >
            無料で相談してみる
            <FontAwesomeIcon
              :icon="faAngleRight"
              class="fa-fw inline h-4"
            />
          </a>
        </div>
      </div>
      <p class="mb-0 text-center">
        <span class="mb-1 inline-block">当日1時間後からOK（8:00〜24:00）</span>
        <br>
        無理な勧誘は一切ありません。
      </p>

      <!-- CEOクローンへのリンクボタン -->
      <div
        v-if="ceoClone"
        class="co-display-12 mt-6 text-center"
      >
        <span class="font-bold">
          <slot name="briefingLead">
            動画でサービスの内容が詳しくわかる！
          </slot>
        </span>
        <div class="text-center">
          <a
            :href="link"
            target="_blank"
            style="width: 15.25rem"
            class="co-btn-secondary mt-3 inline-flex items-center justify-center"
          >
            無料の説明動画を見る
            <FontAwesomeIcon
              :icon="faAngleRight"
              class="fa-fw inline h-4"
            />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleRight } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faAngleRight,
    }
  },
  props: {
    sidejob: {
      type: Boolean,
    },
    link: {
      type: String,
      default: null,
    },
    ceoClone: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FontAwesomeIcon,
  }
}

export default defineComponent(options)
</script>

<style scoped>
.te-banner-limited-border::before,
.te-banner-limited-border::after {
  position: absolute;
  top: 100%;
  left: 50%;
  width: 0;
  height: 0;
  content: '';
}

.te-banner-limited-border::after {
  border: 6px solid;
  border-color: transparent;
  border-top-color: #333;
}
</style>
